import { useEffect, useRef } from 'react';

// Use a relative URL so the CRA dev proxy (setupProxy.js) forwards to localhost:5001,
// and Vercel routes it to the serverless function — no hardcoded host needed.
const API_TRACK_URL = '/api/analytics';

export function useTracker(pageName) {
    const hasTracked = useRef(false);
    const trackingId = useRef(null);
    const startTime = useRef(Date.now());

    useEffect(() => {
        // Exclude admin from analytics tracking
        if (localStorage.getItem('adminToken')) return;

        if (hasTracked.current) return;
        hasTracked.current = true;
        startTime.current = Date.now();

        const track = async () => {
            try {
                // Parse specific referrers or default
                let ref = document.referrer || 'Direct';

                const res = await fetch(API_TRACK_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        page: pageName || window.location.pathname,
                        userAgent: navigator.userAgent,
                        platform: navigator.platform,
                        referrer: ref,
                        screenResolution: `${window.screen.width}x${window.screen.height}`
                    })
                });
                
                if (res.ok) {
                    const data = await res.json();
                    if (data.id) trackingId.current = data.id;
                }
            } catch (e) {
                console.error("Analytics tracking failed", e);
            }
        };

        const timer = setTimeout(track, 1000);

        // Cleanup function fires when the component unmounts (user leaves page)
        return () => {
            clearTimeout(timer);
            if (trackingId.current) {
                const durationInSeconds = Math.round((Date.now() - startTime.current) / 1000);
                
                // Use keepalive to ensure request fires even as the page unloads
                fetch(`${API_TRACK_URL}/${trackingId.current}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ duration: durationInSeconds }),
                    keepalive: true
                }).catch(() => {});
            }
        };
    }, [pageName]);
}
